import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { listDeliveries, notifyAvailable } from '../../../../api-new/state/notify'
import { timelinePath } from './paths'

// Email activity's link to the notify timeline (spec section 13): an email
// sent through the notification platform opens the whole path it took.
// When the message names its notification (notificationId) the link is
// direct; otherwise notify is asked which delivery sent this email (C-4
// GET /notify/deliveries?emailMessageId=, in the page's own scope). Best
// effort: an email notify didn't send, a refusal (no SYS_NOTIFY on the
// staff page) or notify unreachable shows nothing.
// row: as a Details row (<dt>Notification</dt><dd>link</dd>).
export const NotifyTimelineLink = ({ messageId, notificationId, system = false, row = false }) => {
  const available = notifyAvailable()
  const [found, setFound] = useState(notificationId || null)

  useEffect(() => {
    if (!available || notificationId || !messageId) return undefined
    let live = true
    listDeliveries({ scope: system ? 'system' : 'organization', emailMessageId: messageId, limit: 1 }).then(
      page => {
        const d = page && page.items && page.items[0]
        if (live && d && d.notificationId) setFound(d.notificationId)
      },
      () => {}
    )
    return () => {
      live = false
    }
  }, [available, messageId, notificationId, system])

  if (!available || !found) return null
  const link = <Link to={timelinePath(found, system)}>Open the notification timeline</Link>
  return row ? <><dt>Notification</dt><dd>{link}</dd></> : link
}
